import * as React from 'react';


export const portfolio = [
  
  {
    id: 2,
    title: 'Hotel F6',
    client: 'Royal Ravintolat Oy',
    date: '2016-2018',
    excerpt: <p>Suunnittelimme verkkosivuston Helsingin ehkä viehättävimmälle boutique-hotellille, Hotel F6:lle. Fabianinkadulla sijaitsevan hotellin alakerrassa sijaitsee myös Bar Runar, jonka senkin sivusto on käsialaamme.</p>,
    image_url: require( '../assets/images/portfolio/hotel_f6_v2.png' ),
    background_url: require( '../assets/images/portfolio/hotel-f6_bg_v2.jpg' ),
    background_color: '#94824c',
    links: [
      {
        title: 'Hotel F6:n verkkosivusto',
        url: 'https://www.hotelf6.fi'
      },
      {
        title: 'Bar Runarin verkkosivusto',
        url: 'https://www.runar.fi'
      }

    ]
  },
  {
    id: 3,
    title: 'AV-Arkki & Mediataide kasvattaa!',
    client: 'AV-ARKKI RY',
    date: '2017-2019',
    excerpt: <p>AV-Arkki on suomalaisen mediataiteen keskus – taiteilijoiden perustaman yhdistus, jonka jäseninä on yli 250 suomalaista tai Suomessa asuvaa mediataiteilijaa. <br /><br />Olemme suunnitelleet ja toteuttaneet sekä AV-Arkin oman, taiteilijoita esittelevän sivuston, että media- ja taidekasvatuksen oppimateriaaleja tuottavan ja tarjoavan Mediataide kasvattaa! -verkkopalvelun.</p>,
    image_url: require( '../assets/images/portfolio/av-arkki.png' ),
    background_url: require( '../assets/images/portfolio/gradient-bg-2.jpg' ),
    background_color: '#cc5e58',
    links: [
      {
        title: 'AV-Arkki.fi',
        url: 'http://www.av-arkki.fi'
      },
      {
        title: 'Mediataide kasvattaa!',
        url: 'http://www.mediataidekasvattaa.fi'
      }
    ]
  },
  {
    id: 1,
    title: 'Finest Link',
    client: 'Uudenmaan Liitto',
    date: '2017 – 2018',
    excerpt: <p>Olimme mukana viestintää ja visuaalista ilmettä suunnittelevana kumppanina Helsingin ja Tallinnan välille tunneliyhteyttä selvittävässä FinEst Link -hankkeessa. <br /><br />Kairon toteuttama 12-minuuttinen hanketta esittelevä infografiikka-animaatio esitettiin projektin loppukonferenssissa Tallinnassa helmikuussa 2018.</p>,
    image_url: require( '../assets/images/portfolio/finestlink-v3.png' ),
    background_url: require( '../assets/images/portfolio/finestlink_bg3.jpg' ),
    background_color: '#101b2e',
    links: [
      {
        title: 'Katso Video',
        url: 'https://www.youtube.com/watch?v=OmZsqMq5mXw'
      },
      {
        title: 'Vieraile verkkosivuilla',
        url: 'http://www.finestlink.fi'
      }
    ]
  },
  {
    id: 4,
    title: 'Ilmastoviisas alue',
    client: 'HSY',
    date: '2019',
    excerpt: <p>Suunnitelimme ja toteutimme HSY:lle Ilmastoviisas alue -suunnittelutyökalun, joka esittelee yhteiset toimenpidekortit asemanseudun hankkeiden tilaajille, suunnittelijoille ja toteuttajille. <br/><br/>Kortteihin on koottu konkreettisia keinoja edistää ilmastotavoitteita ja kestävän kehityksen tavoitteita kaupunkisuunnittelussa.</p>,
    image_url: require( '../assets/images/portfolio/hsy_v1.png' ),
    background_url: require( '../assets/images/portfolio/hsy_bg_2.jpg' ),
    background_color: '#cc5e58',
    links: [
      {
        title: 'Ilmastoviisasalue.fi',
        url: 'http://www.ilmastoviisasalue.fi'
      }
    ]
  },
  {
    id: 7,
    title: 'Sarjiskone ja Koululehtikone',
    client: 'Aikakausmedia',
    date: '2014–2017',
    excerpt: <p>Suunnittelimme ja toteutimme Aikakausmedialle kaksi kouluille suunnattua palvelua: Sarjiskoneen ja Koululehtikoneen.<br/><br/>Sarjiskone on verkkopohjainen piirustusohjelma sarjisten tekemiseen. Koululehtikone on palvelu, jossa oppilaat voivat suunnitella ja julkaista omia digijulkaisujaan ryhminä. <br/><br/>Palveluiden ytimessä on median lukemisen ja ryhmätyötaitojen opettaminen lapsille.</p>,
    image_url: require( '../assets/images/portfolio/sarjakuvakone_v2.png'),
    background_url: require( '../assets/images/portfolio/sarjakuvakone_bg_v2.jpg'),
    background_color: '#e3cc2c',
    links: [
      {
        title: 'Sarjiskone',
        url: 'http://www.sarjiskone.fi'
      },
      {
        title: 'Koululehtikone',
        url: 'http://www.koululehtikone.fi'
      }
    ]
  },
  {
    id: 5,
    title: 'Almaco.com -verkkosivusto',
    client: 'Almaco Oy',
    date: '2017',
    excerpt: <p>Almaco on kansainvälinen risteilyalusten ja porauslauttojen rakennus- ja modernisointikumppani. Toteuttamamme verkkosivusto esittelee Almacon toimintaa, marine- ja offshore-toimialoja ja case-esimerkkejä yrityksen toteuttamista hankkeista.</p>,
    image_url: require( '../assets/images/portfolio/almaco_v2.png' ),
    background_url: require( '../assets/images/portfolio/almaco_bg-3.jpg' ),
    background_color: '#152846',
    links: [
      {
        title: 'Almaco.cc',
        url: 'http://www.almaco.cc'
      }
    ]
  },


  {
    id: 6,
    title: 'Ajasto Kalenterit',
    client: 'Ajasto',
    date: '2016-2020',
    excerpt: <p>Olemme suunnitelleet Ajastolle useita kalenterikonsepteja ja -mallistoja vuodesta 2016 alkaen. Tuotteiden kohderyhmät ovat vaihdelleet koululaisista eläkeläisiin ja bujoilijoista skräppääjiin – tavoitteena löytää uuniikkeja ominaisuuksia, jotka piristävät kantajansa arkea ja tekevät tulevaisuuden suunnittelusta helpompaa. Suunnittelemiamme kalenterimallistoja ovat mm. Note, Doodle, Color, Maker, Ark ja Kamu, sekä seinäkalenterit Eden, Aikamatka ja Uni.</p>,
    image_url: require( '../assets/images/portfolio/ajasto.png'),
    background_url: require( '../assets/images/portfolio/kkv_bg.gif'),
    background_color: '#0092cf',
    links: [
      {
        title: 'Ajaston verkkokauppa',
        url: 'https://www.ajasto.fi/collections/all'
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/data/PortfolioData.tsx